export enum Theme {
  Default = 'default',
  Dark = 'dark',
}
